import clsx from "clsx";
import { useContext } from "react";
import { NewsContext } from "@";
import { routesFlat } from "@routes";
import * as global from "@components";
import * as components from "./components";
import * as constants from "./constants";

export default function Landing() {
    const { articles } = useContext(NewsContext);
    const cards = articles.slice(0, 6);
    const newsProps = {
        cards,
        header: "News",
        bg: "bg-blue",
    };
    return (
        <>
            <global.MetaTagHeader {...constants.metaDataHeader} />
            <div className={parentContainerStyle}>
                <components.ScrollProgress />
                <components.Hero />
                <components.Solutions />
                <components.WhyCTrees />
                <global.Data cards={constants.dataCards} />
                <components.Partners />
                <global.Data {...newsProps} />
                <global.Button
                    to={routesFlat.news}
                    className={btnStyle}
                    tertiary={true}
                >
                    read all articles
                </global.Button>
            </div>
            <global.StayConnected />
            {/* <components.DonateCTA /> */}
        </>
    );
}
const parentContainerStyle = clsx(
    "w-full flex flex-col justify-center items-center",
);
const btnStyle = clsx("-mt-20 mb-40 px-10 bg-blue border-transparent");
